export const cardTitleInfo = 'General option info';
export const cardTitleTechInfo = 'Technician option inf';
export const cardTitleEditorInfo = 'Editor option info';
export const cardTitleRegion = 'Region option info';
export const cardTitleAdmin = 'Admin option info';
export const createOptionError = "You haven't completed all the required information to create this option.";
export const createOptionSuccess = 'Successfully created option!';
export const optionNameLabel = 'Name the option (required)';
export const optionNamePlaceholder = 'name...';
export const optionPriceLabel = 'How much does it cost? (required)';
export const optionPricePlaceholder = 'price...';
export const optionImageCountLabel = 'How many files are we delivering? (how many for proofing) (required)';
export const optionImageCountPlaceholder = 'delivered image count...';
export const optionDescriptionLabel = 'Short description for clients. (required)';
export const optionDescriptionPlaceholder = 'this description will show to clients when they are booking services...';
export const optionTypeLabel = 'Option type (required)';
export const quantityLabel = 'What is the default quantity? (required)';
export const quantityQuantity = 'Quantity...';
export const packageTypeLabel = 'When booking, what group should this be seen in? (required)';
export const technicianPayLabel = 'How much does the technician get paid? (Not including $30 base pay) (required)';
export const technicianPayPlaceholder = 'technician pay...';
export const photographerFileCountLabel = 'Technician bracketed set upload limit (required)';
export const photographerFileCountPlaceholder = 'max # of bracketed sets to upload... ';
export const payTimeLabel = 'How long is this expected to take a technician? (required)';
export const payTimePlaceholder = 'estimated service length (min)...';
export const photographerInstructionsLabel = 'technician instructions (required)';
export const photographerInstructionsPlaceholder = 'technician instructions for this option...';
export const durationLabel = 'duration (required)';
export const durationPlaceholder = 'video duration...';
export const certTechLabel = 'required certifications for technician';
export const certTechPlaceholder = 'add a certification...';
export const noOptionText = 'this option has no required photographer certifications yet';
export const noEditorCertText = 'this option has no required editor certifications yet';
export const editorInstructionsLabel = 'Instructions for the editor (required)';
export const editorInstructionsPlaceholder = 'editor instructions...';
export const addCertLabel = 'required certifications for editors';
export const addCertPlaceholder = 'add a certification...';
export const optionsDropdownLabel = 'What regions should this option be available in? (required)';
export const optionsDropdownMessage = 'There are no more available regions to add. If you believe this to be an error, please contact the developers.';
export const selectOptionLabel = 'SELECT OPTION';
export const addRegionPlaceholder = 'add a region...';
export const requiredInfoPlaceholder = 'Required info...';
export const requiredInfoLabel = 'What extra info is required to be given? (required)';
export const requiredInfoPromptPlaceholder = 'Placeholder text for the required notes you have required for this option...';
export const requiredInfoPromptLabel = 'Placeholder for the required notes.';
export const regionLabel = 'SEARCH OPTIONS BY REGION';
export const regionPlaceholder = 'Select a region...';
export const selectOptionPlaceholder = 'Select an option...';
export const noAdditionalOptionsText = 'No additional options yet ask an admin!';
export const noAdditionalOptionsTextAlt =
	'This option has no additional options yet. When you add one they will only appear to your client if they have also selected this option.';
export const assignButton = 'assign';
